/**
 *  @class
 *  @function ViewProducts
 */
if (!customElements.get('view-products')) {
  class ViewProducts extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.querySelector(this.dataset.target);
      this.addEventListener('click', this.setupEventListener.bind(this));

      // WCAG 2.1.1 — il custom element ha role=button: gestiamo Enter/Space da tastiera
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          this.setupEventListener();
        }
      });
    }
    setupEventListener() {
      document.body.classList.add('open-cc');
      this.drawer.classList.add('active');
    }
  }
  customElements.define('view-products', ViewProducts);
}
